var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "rt-navigation-bar-container" },
      [
        _vm.isLoginNavBar
          ? _c("login-nav-bar", {
              staticClass: "rt-navigation-bar",
              attrs: { homeIcon: _vm.homeIcon },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.shouldShowSignupNav
          ? _c("signup-nav-bar", {
              attrs: {
                signupStep: _vm.currentNavStep,
                signupTitle: _vm.signupNavTitle,
                homeIcon: _vm.homeIcon,
                shouldShowSignupNavButtons: _vm.shouldShowSignupNavButtons,
                isStudentNav: _vm.isStudentSignupNav,
              },
              on: { stepCompleted: _vm.handleStepCompleted },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.isCommonNavBar
          ? _c("common-nav-bar", {
              staticClass: "rt-navigation-bar",
              class: { "teacher-navbar": _vm.isTeacherNav },
              attrs: {
                isTeacherNav: _vm.isTeacherNav,
                isMobileNav: _vm.isMobile,
                username: _vm.currentUsername,
                userIcon: _vm.userIcon,
                avatarColor: _vm.avatarColor,
                showPremium: _vm.premiumOptionVisible,
                showActivityRibbon: _vm.isActivityRibbonVisible,
                showSalesRibbon: _vm.isSalesRibbonVisible,
                currentNavName: _vm.currentNav,
                leftNavButtons: _vm.leftNavButtons,
                dropdownButtons: _vm.dropdownButtons,
              },
              on: {
                dropdownClicked: _vm.handleDropdownEvent,
                pemiumButtonClicked: _vm.openSubscriptionDialog,
                onShowSubscribe: _vm.openSubscriptionDialog,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("profile-settings-modal", {
          attrs: { show: _vm.settingModalOpened },
          on: {
            onSubscription: function ($event) {
              _vm.isSubscriptionDialogOpened = true
            },
            close: _vm.closeProfileModal,
          },
        }),
        _vm._v(" "),
        _c("subscription-dialog", {
          attrs: {
            show: _vm.isSubscriptionDialogOpened,
            name: "navigation-subscription-modal",
          },
          on: {
            closeDialog: function ($event) {
              _vm.isSubscriptionDialogOpened = false
            },
          },
        }),
        _vm._v(" "),
        _c("my-teacher-modal", {
          attrs: { show: _vm.teacherModalOpened },
          on: { close: _vm.closeTeacherModal },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }